import { DataBean } from "../DataBean";

export class ErrorTypes extends DataBean {

  public async getErrorTypesCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getErrorTypesCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteErrorTypes(iderrortypes: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteErrorTypes_Number", [iderrortypes]);
  }

  public async updateErrorTypes(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.ErrorTypes_updateErrorTypes_com.orange.finance.processcontract.bean.ErrorTypes",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.ErrorTypes",
        },
      ]
    );
  }
}
